import {RestResource} from '../rest'
import {NOTICE_SERVER} from '../server'
import {athubAxios} from "@/util";

const notice = new RestResource({server: NOTICE_SERVER, resource: 'notice'});

notice.publish = (noticeDetail) => {
    let url = `${NOTICE_SERVER}/notice/publish`;
    return new Promise((resolve, reject) => {
        athubAxios.put(url, noticeDetail).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

notice.unPublish = (noticeDetail) => {
    let url = `${NOTICE_SERVER}/notice/unPublish`;
    return new Promise((resolve, reject) => {
        athubAxios.put(url, noticeDetail).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

export default notice;